const getMapThumbnailLink = ({ id, updatedAt }) => {
  return `${process.env.NEXT_PUBLIC_MAP_DATA_URL}/maps/${id}/thumbnail.png?ts=${updatedAt}`
}
export { getMapThumbnailLink }
